import { Component } from "@angular/core";

@Component({
  selector: "app-retailer-payout",
  templateUrl: "./retailer-payout.component.html",
  styleUrls: ["./retailer-payout.component.less"],
})
export class RetailerPayoutComponent {}
